import { render, staticRenderFns } from "./ClassesDetials.vue?vue&type=template&id=18dc2888&scoped=true&"
import script from "./ClassesDetials.vue?vue&type=script&lang=js&"
export * from "./ClassesDetials.vue?vue&type=script&lang=js&"
import style0 from "./ClassesDetials.vue?vue&type=style&index=0&id=18dc2888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dc2888",
  null
  
)

export default component.exports